import {lazy} from 'react';

import {CountryOfOriginGroup} from './kit/groups/CountryOfOriginGroup';
import {DimensionsGroup} from './kit/groups/DimensionsGroup';
import {EmissionsGroup} from './kit/groups/EmissionsGroup';
import {EngineInfoGroup} from './kit/groups/EngineInfoGroup';
import {EngineSpecsGroup} from './kit/groups/EngineSpecsGroup';
import {ExteriorColorGroup} from './kit/groups/ExteriorColorGroup';
import {FuelConsumptionGroup} from './kit/groups/FuelConsumptionGroup';
import {FuelGroup} from './kit/groups/FuelGroup';
import {MileageGroup} from './kit/groups/MileageGroup';
import {OwnershipGroup} from './kit/groups/OwnershipGroup';
import {RegistrationNumberGroup} from './kit/groups/RegistrationNumberGroup';
import {ServiceInspectionGroup} from './kit/groups/ServiceInspectionGroup';
import {VehicleRegistrationDetailsGroup} from './kit/groups/VehicleRegistrationDetailsGroup';
import {WeightGroup} from './kit/groups/WeightGroup';
import {BatteryHealthSubSection} from './ui/subsections/BatteryHealthSubSection';
import {BrakeFluidReplacementSubSection} from './ui/subsections/BrakeFluidReplacementSubSection';
import {ConsumptionEmissionsSubSection} from './ui/subsections/ConsumptionEmissionsSubSection';
import {CoolantFluidReplacementSubSection} from './ui/subsections/CoolantFluidReplacementSubSection';
import {DimensionsWeightSubSection} from './ui/subsections/DimensionsWeightSubSection';
import {EngineBasicsSubSection} from './ui/subsections/EngineBasicsSubSection';
import {EngineDetailsSubSection} from './ui/subsections/EngineDetailsSubSection';
import {EngineOilReplacementSubSection} from './ui/subsections/EngineOilReplacementSubSection';
import {FeatureAutofillSubSection} from './ui/subsections/FeatureAutofillSubSection';
import {FeatureMarketAnalysisSubSection} from './ui/subsections/FeatureMarketAnalysisSubSection';
import {FeatureSelectorSubSection} from './ui/subsections/FeatureSelectorSubSection';
import {FourByFourOilDistributorReplacementSubSection} from './ui/subsections/FourByFourOilDistributorReplacementSubSection';
import {GearboxOilReplacementSubSection} from './ui/subsections/GearboxOilReplacementSubSection';
import {IntegrationWidgetsSubSection} from './ui/subsections/IntegrationWidgetsSubSection';
import {MileageOwnershipSubSection} from './ui/subsections/MileageOwnershipSubSection';
import {RegistrationDocumentsSubSection} from './ui/subsections/RegistrationDocumentsSubSection';
import {RentalInformationSubSection} from './ui/subsections/RentalInformationSubSection';
import {ServiceBookSubSection} from './ui/subsections/ServiceBookSubSection';
import {ServiceInspectionReplacementSubSection} from './ui/subsections/ServiceInspectionReplacementSubSection';
import {ServiceInspectionSubSection} from './ui/subsections/ServiceInspectionSubSection';
import {TechnicalInspectionSubSection} from './ui/subsections/TechnicalInspectionSubSection';
import {TimingBeltReplacementSubSection} from './ui/subsections/TimingBeltReplacementSubSection';
import {VehicleBasicsSubSection} from './ui/subsections/VehicleBasicsSubSection';
import {VehicleConditionSubSection} from './ui/subsections/VehicleConditionSubSection';
import {VehicleConfigurationSubSection} from './ui/subsections/VehicleConfigurationSubSection';
import {VehicleIdentificationSubSection} from './ui/subsections/VehicleIdentificationSubSection';
import {VehicleRegistrationCountriesSubSection} from './ui/subsections/VehicleRegistrationCountriesSubSection';
import {VehicleRegistrationSubSection} from './ui/subsections/VehicleRegistrationSubSection';
import {VehicleSourceSubSection} from './ui/subsections/VehicleSourceSubSection';
import {VehicleStylingSubSection} from './ui/subsections/VehicleStylingSubSection';
import {VehicleWarrantiesSubSection} from './ui/subsections/VehicleWarrantiesSubSection';
import {WarrantySubSection} from './ui/subsections/WarrantySubSection';

// German-specific components (lazy loaded)
export const GermanSpecificFields = lazy(() =>
  import('./kit/components/GermanSpecificFields').then((module) => ({
    default: module.GermanSpecificFields,
  }))
);

export const LoadingSpaceDimensionsGroup = lazy(() =>
  import('./kit/groups/LoadingSpaceDimensionsGroup').then((module) => ({
    default: module.LoadingSpaceDimensionsGroup,
  }))
);

// Field Groups
export const VehicleFieldGroups = {
  Fuel: FuelGroup,
  VehicleRegistrationDetails: VehicleRegistrationDetailsGroup,
  EngineSpecs: EngineSpecsGroup,
  ExteriorColor: ExteriorColorGroup,
  EngineInfo: EngineInfoGroup,
  FuelConsumption: FuelConsumptionGroup,
  Emissions: EmissionsGroup,
  Dimensions: DimensionsGroup,
  LoadingSpaceDimensions: LoadingSpaceDimensionsGroup,
  Weight: WeightGroup,
  CountryOfOrigin: CountryOfOriginGroup,
  Mileage: MileageGroup,
  Ownership: OwnershipGroup,
  RegistrationNumber: RegistrationNumberGroup,
  ServiceInspection: ServiceInspectionGroup,
  GermanSpecific: GermanSpecificFields,
};

// SubSections
export const VehicleSubSections = {
  VehicleIdentification: VehicleIdentificationSubSection,
  VehicleBasics: VehicleBasicsSubSection,
  VehicleRegistration: VehicleRegistrationSubSection,
  VehicleConfiguration: VehicleConfigurationSubSection,
  EngineBasics: EngineBasicsSubSection,
  VehicleStyling: VehicleStylingSubSection,
  EngineDetails: EngineDetailsSubSection,
  ConsumptionEmissions: ConsumptionEmissionsSubSection,
  DimensionsWeight: DimensionsWeightSubSection,
  ServiceBook: ServiceBookSubSection,
  ServiceInspection: ServiceInspectionSubSection,
  ServiceInspectionReplacement: ServiceInspectionReplacementSubSection,
  TechnicalInspection: TechnicalInspectionSubSection,
  BatteryHealth: BatteryHealthSubSection,
  Warranty: WarrantySubSection,
  Warranties: VehicleWarrantiesSubSection,
  VehicleCondition: VehicleConditionSubSection,
  MileageOwnership: MileageOwnershipSubSection,
  RegistrationDocuments: RegistrationDocumentsSubSection,
  VehicleSource: VehicleSourceSubSection,
  FeatureSelector: FeatureSelectorSubSection,
  IntegrationWidgets: IntegrationWidgetsSubSection,
  FeatureMarketAnalysis: FeatureMarketAnalysisSubSection,
  FeatureAutofill: FeatureAutofillSubSection,
  VehicleRegistrationCountries: VehicleRegistrationCountriesSubSection,
  EngineOilReplacement: EngineOilReplacementSubSection,
  GearboxOilReplacement: GearboxOilReplacementSubSection,
  FourByFourOilDistributorReplacement: FourByFourOilDistributorReplacementSubSection,
  TimingBeltReplacement: TimingBeltReplacementSubSection,
  BrakeFluidReplacement: BrakeFluidReplacementSubSection,
  CoolantFluidReplacement: CoolantFluidReplacementSubSection,
  RentalInformation: RentalInformationSubSection,
};

// Main Components
export {VehicleForm} from './kit/VehicleForm';
export {VehicleFormProvider} from './kit/VehicleFormProvider';
export {VehicleFormContext} from './kit/VehicleFormContext';
export {StepBoundary} from './kit/StepBoundary';
export {useIsVehicleQualitySealShown} from './hooks/useIsVehicleQualitySealShown';
export {buildQualitySealOptions} from './utils/buildQualitySealOptions';

// Base Vehicle
export * from './core/types/BaseVehicle';
export * from './core/schema/BaseVehicleValidationSchema';
export * from './core/schema/VehicleWarrantyRowSchema';

// Sale Vehicle
export * from './core/schema/SaleVehicleValidationSchema';
export * from './core/types/SaleVehicle';

// Rental Vehicle
export * from './core/schema/RentalVehicleValidationSchema';
export * from './core/types/RentalVehicle';

// Service Vehicle
export * from './core/schema/ServiceVehicleValidationSchema';
export * from './core/types/ServiceVehicle';

// Converters
export * from './core/converters/toAPIVehicle';
export * from './core/converters/toBaseVehicle';

// Constants
export * from './core/constants/makeModel';
export * from './core/constants/SERVICE_INTERVALS_DEFAULT_VALUES';

// UI Components
export * from './ui/components/VehicleFormDefaultLayout';
export * from './ui/components/AdditionalNote';
export * from './ui/components/PriceGroupCard';

// Kit Components
export {
  FileField,
  type FileFieldValue,
  type FileFieldProps,
} from './kit/components/fields/FileField';

// UI SubSections
export {ConsumptionEmissionsSubSection} from './ui/subsections/ConsumptionEmissionsSubSection';

// UI Hooks
export {useVehicleFormContext} from './kit/hooks/useVehicleFormContext';
export {useVehicleCreateMakeModel} from './kit/hooks/useVehicleCreateMakeModel';
export {useGetTenantInfo} from './kit/hooks/useGetTenantInfo';
export {useWizardTabRouting} from './kit/hooks/useWizardTabRouting';
export {useWizardIndicators} from './kit/hooks/useWizardIndicators';
export {useFormKeyboardNavigation} from './kit/hooks/useFormKeyboardNavigation';
export {useVehicleVariant} from './kit/hooks/useVehicleVariant';
export {useVehicleVariantSync} from './kit/hooks/useVehicleVariantSync';
export {useVehicleDocumentSync} from './kit/hooks/useVehicleDocumentSync';
export {useVehicleWarrantySync} from './kit/hooks/useVehicleWarrantySync';
export {useUpdateVehicleType} from './kit/hooks/useUpdateVehicleType';
export {
  useSimilarVehicleHandler,
  type SimilarVehicleHandlerState,
} from './kit/hooks/useSimilarVehicleHandler';
export {useBaseVehicleWizard} from './ui/hooks/useBaseVehicleWizard';
export {useIsCardExpandable} from './ui/hooks/useIsCardExpandable';
export {useGetCarFeatures} from './ui/hooks/useGetCarFeatures';
export {useAdditionalNote} from './ui/hooks/useAdditionalNote';
export {useFormNavigate} from './ui/hooks/useFormNavigate';
export {useIntegrationsEnabled} from './kit/hooks/useIntegrationsEnabled';
export {useDebouncedWatch} from './kit/hooks/useDebouncedWatch';

// Utils
export * from './kit/utils/buildBatteryCertificateFileFields';
export * from './kit/utils/isTrailerOrSemitrailer';
export * from './kit/utils/isVanOrTruck';
export * from './kit/utils/isElectricOrHybridFuelType';
export * from './utils/resolveInitialWarrantyDuration';

// Machine events
export {VEHICLE_FORM_EVENTS} from './core/machine/constants/VEHICLE_FORM_EVENTS';
